import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';
import Footer from '../component/Footer';


import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, EffectCoverflow } from 'swiper/modules';

import TitleView from '../component/TitleView';

export default function Page6(props) {

    const [swp, setSwp] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);
    const ary = [
        'banner_0.jpg', 'banner_1.jpg', 'banner_2.jpg', 'banner_3.jpg', 'banner_4.jpg',
        'banner_0.jpg', 'banner_1.jpg', 'banner_2.jpg', 'banner_3.jpg', 'banner_4.jpg',
        'banner_0.jpg', 'banner_1.jpg', 'banner_2.jpg', 'banner_3.jpg', 'banner_4.jpg'
    ];

    React.useEffect(() => {

    }, []);

    function leftTap() {
        swp && swp.slidePrev();
    }

    function rightTap() {
        swp && swp.slideNext();
    }

    function indexChanged() {

    }

    return (
        <Stack
            id={props.anchorId}
            sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                position: 'relative',
            }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath('bg/bg_6.png')}
                sx={{
                    width: 1,
                    height: settingData.innerHeight,
                    objectFit: 'cover',
                    zIndex: 1,
                    position: 'absolute',
                }} />

            <Stack sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2
            }}>

                <TitleView title='Game Features' mt={'90rem'} />

                <Stack sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2,
                    flex: 0.8, //高度充满
                    position: 'relative',
                    pb: '100rem',
                }}>

                    <Box
                        onClick={leftTap}
                        component={'img'}
                        src={JSTool.getImgPath('news_left.png')}
                        sx={{
                            height: '30rem',
                            cursor: 'pointer',
                            transitionDuration: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.3)',
                            }
                        }} />

                    <Swiper style={{
                        width: '750rem',
                        margin: '20rem',
                        paddingLeft: '100rem',
                        paddingRight: '100rem',
                    }}

                        modules={[Autoplay, EffectCoverflow]}
                        effect={'coverflow'}
                        grabCursor={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{
                            rotate: 0,
                            stretch: 475,
                            depth: 450,
                            modifier: 1,
                            slideShadows: true,
                        }}

                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}


                        onSlideChangeTransitionEnd={(sp) => {
                            indexChanged();
                        }}

                        onSwiper={(swiper) => {
                            setSwp(swiper);
                            setTimeout(() => { // 延迟执行，确保组件完全加载
                                swiper.slideTo(1);
                            }, 0); // 使用 0 表示立即执行，但放在队列中等待 DOM 更新完成
                        }}>

                        {ary.map((item, index) => {
                            return (<SwiperSlide key={index}><Item item={item} index={index} /></SwiperSlide>)
                        })}

                    </Swiper>

                    <Box
                        onClick={rightTap}
                        component={'img'}
                        src={JSTool.getImgPath('news_right.png')}
                        sx={{
                            height: '30rem',
                            cursor: 'pointer',
                            transitionDuration: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.3)',
                            }
                        }} />

                </Stack>

            </Stack>

            <Footer />
        </Stack>
    );
}



function Item(props) {
    return (
        <Stack sx={{
            position: 'relative',
        }}>
            <Box component={'img'}
                src={JSTool.getImgPath(`banner/${props.item}`)}
                sx={{

                }} />

        </Stack>
    );
}


